import { heatRanking } from '@/mocks/homeData';
import SectionHead from './SectionHead';

function parseHeat(heat: string): number {
  const num = parseFloat(heat);
  return Number.isNaN(num) ? 0 : num;
}

const maxHeat = Math.max(...heatRanking.map((r) => parseHeat(r.heat)));

function rankStyle(rank: number): string {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-accent-500 text-secondary-950';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-700';
}

export default function HeatRanking() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <SectionHead
          zone="分区 02"
          title="热度榜 · 每小时刷新"
          desc="按讨论量、转评量与话题增速综合计算，位次变化每小时更新一次。"
          extra={
            <div className="flex flex-wrap items-center gap-3 font-label text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-arrow-up-line text-primary-500" aria-hidden="true"></i>上升
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-arrow-down-line text-secondary-500" aria-hidden="true"></i>下降
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-subtract-line text-foreground-400" aria-hidden="true"></i>持平
              </span>
            </div>
          }
        />

        <ol className="mt-6 flex flex-col gap-2.5">
          {heatRanking.map((item) => {
            const width = Math.max(12, Math.round((parseHeat(item.heat) / maxHeat) * 100));
            return (
              <li key={item.rank}>
                <a
                  href="#clash"
                  className="group flex cursor-pointer items-center gap-3 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-200/70 md:gap-5 md:p-4"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-black md:h-11 md:w-11 md:text-lg ${rankStyle(
                      item.rank,
                    )}`}
                  >
                    {item.rank}
                  </span>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="shrink-0 rounded-sm border border-background-300 px-1.5 py-0.5 font-label text-[10px] text-foreground-500">
                        {item.category}
                      </span>
                      <h4 className="truncate font-heading text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                        {item.title}
                      </h4>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="grow-bar h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
                        style={{ width: `${width}%` }}
                      ></div>
                    </div>
                  </div>

                  <div className="flex shrink-0 flex-col items-end gap-1">
                    <span className="font-heading text-sm font-black text-foreground-950 md:text-base">
                      {item.heat}
                    </span>
                    <span
                      className={`flex items-center gap-0.5 font-label text-[11px] ${
                        item.delta === 'up'
                          ? 'text-primary-600'
                          : item.delta === 'down'
                            ? 'text-secondary-500'
                            : 'text-foreground-400'
                      }`}
                    >
                      <i
                        className={
                          item.delta === 'up'
                            ? 'ri-arrow-up-s-fill'
                            : item.delta === 'down'
                              ? 'ri-arrow-down-s-fill'
                              : 'ri-subtract-line'
                        }
                        aria-hidden="true"
                      ></i>
                      {item.deltaText}
                    </span>
                  </div>
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}